<style>
.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient( rgba(255,255,255,0.7), rgba(255,255,255,0.7) ), url("/i/edit-questions.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.card{
  position: fixed;
  top: 50%;
  left: 20px;
  right: 20px;
  margin-top: -200px;
  
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 20px;
  padding: 20px;
}

.scale{
  display: grid;
  grid-template-columns: 16% 16% 16% 16% 16%;
  /* width: 250px; */
  height: 50px;
  margin-top: 40px;
}

.scale1{
  grid-column: 1;
  text-align: center;
}
.scale2{
  grid-column: 2;
  text-align: center;
}
.scale3{
  grid-column: 3;
  text-align: center;
}
.scale4{
  grid-column: 4;
  text-align: center;
}
.scale5{
  grid-column: 5;
  text-align: center;
}
.scale6{
  grid-column: 6;
  text-align: center;
}

.scale-bg{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
}
.scale-bg1{
  grid-column: 1;
  grid-row: 1;
  border-right: 1px white solid;
  height: 25px;
}
.scale-bg2{
  grid-column: 2;
  grid-row: 1;
  height: 25px;
}
.scale-bg3{
  grid-column: 1;
  grid-row: 2;
  border-top: 1px white solid;
  border-right: 1px white solid;
  height: 25px;
}
.scale-bg4{
  grid-column: 2;
  grid-row: 2;
  border-top: 1px white solid;
  height: 25px;
}
.scale-icon{
  margin: auto;
  margin-top: -35px;
}
.icon-check{
  width: 26px;
  height: 26px;
  border-radius: 26px;
  background-color: white;
}

.small-print{
  margin-top: 50px;
  text-align: center;
  font-size: 16px;
}

.text{
  display: grid;
  grid-template-columns: 16px auto auto 16px;
  font-size: 16px;
  margin-top: 10px;
}
.left-arrow{
  grid-column: 1;
}
.left-text{
  grid-column: 2;
}
.right-text{
  grid-column: 3;
  text-align: right;
}
.right-arrow{
  grid-column: 4;
}

.next{
  position: fixed;
  bottom: 20%;
  left: 20px;
  right: 20px;
  text-align: center;
}

button{
  border: 0;
  color: black;
  width: 50%;
}

.amount{
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  font-size: 16px;
  font-style: italic;
  color: black;
  text-align: center;
}
</style>

<Header 
  back="{true}"
  buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }] }"
  white="{true}"
  on:addEvent="{ () => push('/create-new-event') }"
  on:back="{ () => { pop() } }">
  Answer Questions
</Header>
<div class="has-header"></div>

<Dialog show="{newUserShow}" title="" cancel="{false}" close="{false}" buttons="{ [ {text: 'Got It!', callback: 'close', disabled: false, }, ] }" on:close="{closeDialog}">
  Answering questions helps us find likeminded people to match you with.<br>
  <br>
  Answer as many as you can!
</Dialog>


<div class="bg"></div>


<div class="card">
  Q: {questions[question].question}<br>
  <br>
  
  {#if questions[question].type == "scale1-5"}
  A: { questions[question].selected != 0 ? questions[question].answers[ questions[question].selected - 1 ] : 'No Answer' }
  {/if}
  
  
  {#if questions[question].type == "scale1-5"}
    <div class="scale">
      <div class="scale1" on:click="{ () => {questions[question].selected = 0} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 0}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
        
      </div>
      <div class="scale2" on:click="{ () => {questions[question].selected = 1} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 1}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
        
      </div>
      
      <div class="scale3" on:click="{ () => {questions[question].selected = 2} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 2}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
      </div>
      
      <div class="scale4" on:click="{ () => {questions[question].selected = 3} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 3}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
      </div>
      
      <div class="scale5" on:click="{ () => {questions[question].selected = 4} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 4}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
      </div>
      
      <div class="scale6" on:click="{ () => {questions[question].selected = 5} }">
        <div class="scale-bg">
          <div class="scale-bg1"></div>
          <div class="scale-bg2"></div>
          <div class="scale-bg3"></div>
          <div class="scale-bg4"></div>
        </div>
        
        {#if questions[question].selected == 5}
          <div class="scale-icon">
            <i class="icon-check"></i>
          </div>
        {/if}
      </div>
    </div>
    
    <div class="text">
      <div class="left-arrow"><i class="icon-arrow_left"></i></div>
      <div class="left-text">{questions[question].leftText}</div>
      <div class="right-text">{questions[question].rightText}</div>
      <div class="right-arrow"><i class="icon-arrow_right"></i></div>
    </div>
    
    <div class="small-print">
      Tap to make your selection
    </div>
    
  {/if}
  
  <div class="next">
    <button>Next</button>
  </div>
  
  <div class="amount">
    You've answered 15% of all questions
  </div>
  
</div>
<!-- {#each items as item, index }
  <div></div>
{/each} -->




<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Header from "../components/Header.svelte";
import Dialog from "../components/Dialog.svelte";

let newUserShow = false;

// which questions is the user viewing?
let question = 0;

import { onMount } from "svelte";
onMount(async () => {
  if ( localStorage.getItem("edit-questions-new-user") == null) {
    localStorage.setItem("edit-questions-new-user", 1)
  }
  newUserShow = localStorage.getItem("edit-questions-new-user");
  
  if (params.question != null && params.question != "") {
    question = params.question;
  }
});




let questions = [
  {question: "Are you indoorsy or outdoorsy?", type: "scale1-5", leftText: "Very Outdoorsy", rightText: "Very Indoorsy", selected: 0, answers: ["Very Outdoorsy", "Somewhat Outdoorsy", "Neutral", "Somewhat Indoorsy", "Very Indoorsy"], },
  
]


function closeDialog() {
  newUserShow = false;
  localStorage.setItem("edit-questions-new-user", 0);
}

</script>